/**
 * Добавление классов к элементу
 * @param element
 * @param className
 * @param isString
 */
function addClass(element, className, isString = false) {
	if (className) {
		if (typeof className === 'string') {
			className = className.split(' ');
		}

		if (isString) {
			return '' + className.join(' ');
		}

		if (element) {
			element.classList.add(...className);
		}
	}
}

/**
 * Удаление классов
 * @param element
 * @param className
 */
function removeClass(element, className) {
	if (className && element) {
		if (typeof className === 'string') {
			className = className.split(' ');
		}

		element.classList.remove(...className);
	}
}

/**
 * Удаление элемента
 * @param element
 */
function removeElement(element) {
	if (!element) return false;
	element.parentNode.removeChild(element);
}

/**
 * Обвертка элемента
 * @param element
 * @param className
 */
function wrap(element, className) {
	const wrapper = document.createElement('div');
	addClass(wrapper, className);

	let cloneElement = element.cloneNode(true);
	wrapper.appendChild(cloneElement);

	element.insertAdjacentHTML('beforebegin', wrapper.outerHTML);

	removeElement(element);
}

/**
 * Вытаскиваем все дата атрибуты у элемента
 * @param node
 * @param isRemoveDataName
 * @returns {{}}
 */
function getDataAttributes(node, isRemoveDataName = false) {
	if (!node) return false;

	let obj = {},
		arr = [].filter.call(node.attributes, function (at) {
			return /^data-/.test(at.name);
		});

	if (arr.length) {
		arr.forEach(function (v) {
			let name = v.name;
			if (isRemoveDataName) name = name.slice(5);
			obj[name] = v.value
		});
	}

	return obj;
}

export {wrap, addClass, removeClass, removeElement, getDataAttributes};
